<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm" v-if="dowdViewTypeArr.length!=0">
            <lay-form-item label="类型" prop="type" mode="inline" >
              <lay-select v-model="typeStr" :show-search="true" :multiple="false">
                <lay-select-option v-for="dowdViewType in dowdViewTypeArr"  :value="dowdViewType.id" :label="dowdViewType.title"></lay-select-option>
                
              </lay-select>
            </lay-form-item>
            <lay-form-item label="代理账号" prop="username" mode="inline"  v-if="typeStr==1" >
              <lay-select v-model="searchSelection" :show-search="true" :multiple="false">
                <lay-select-option  v-for="agent in allAgentNameArr" :key="agent.userId" :value="agent.userId" :label="agent.userName"></lay-select-option>
              </lay-select>
            </lay-form-item>
            <lay-form-item mode="inline">
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item> 
          </lay-form> 

          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">  
             
            <template #type="{ row }">
               <space v-if="row.type==1">
                 代理推广
               </space>
               <space v-else-if="row.type==2">
                 用户分享
               </space>
               <space v-else>
                   自来用户
               </space> 
            </template> 

            <template #state="{ row }">
               <space v-if="row.state==0">
                正常
               </space>
               <space v-else-if="row.state==1">
                指纹重复
               </space>
               <space v-else-if="row.state==2">
                ip重复
               </space>
               <space v-else-if="row.state==3">
                请求头部重复
               </space>
               <space v-else-if="row.state==4">
                设备重复
               </space>
               <space v-else-if="row.state==5">
                老用户 
               </space>
               <space v-else>
                   其他
               </space> 
             
            </template> 

            <template #show="{ row }">
               <space v-if="row.show==0">
                不显示
               </space>
               <space v-else-if="row.type==1">
                 显示
               </space> 
            </template> 

            <template #settlement="{ row }">
              <space v-if="row.state>=3 ">
                 
               </space>
              
               <space v-else-if="row.settlement==0 ">
                 未结
               </space>
               <space v-else-if="row.settlement==1">
                 已结
               </space> 
            </template> 

            <template #officialSettlement="{ row }">
               <space v-if="row.officialSettlement==0">
                 未结
               </space>
               <space v-else-if="row.officialSettlement==1">
                 已结
               </space> 
            </template> 


          </lay-table> 
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
 
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDownloadStatistics,allAgentName,dowdViewType} from '../../api'
  
 
  const searchSelection = ref("")
  const typeStr = ref("0")
  
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  const allAgentNameArr=ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
    type: typeStr
  })
  
  const columns = ref([
    // { title: "id", key: "id", align: "center" },
    { title: "用户id", key: "userId", align: "center"},
    { title: "代理账号", key: "userName", align: "center" }, 
    { title: "设备码", key: "deviceId", align: "center"}, 
    { title: "ip", key: "ip", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "类型", key: "type", align: "center", customSlot: "type" },    
    { title: "平台", key: "platform", align: "center" },    
    { title: "是否结算", key: "settlement", align: "center", customSlot: "settlement" },   
    { title: "请求头", key: "userAgent", align: "center" , ellipsisTooltip: true}, 
    { title: "注册时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllDownloadStatistics = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key ,"type":search.type};
    allDownloadStatistics(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllDownloadStatistics();
  
  const change = (page: any) => {
    getAllDownloadStatistics();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllDownloadStatistics();
  }
   
  const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
       
      }
    })

  }
  allAgentNameList();


   const  dowdViewTypeArr=ref([]);
    
  const alldowdViewTypeList=()=>{
   
    dowdViewType().then((res: any) => { 
      if (res != "" && res.code == 0) {
        dowdViewTypeArr.value = res.data;
      
      } else {
        dowdViewTypeArr.value=[];
       
      }
    })

  }
  alldowdViewTypeList();



  
  </script>
  
  <style scoped>
  </style>